export const identidade = {
  titulo: 'Seu cadastro',
  vinculado: 'Cadastro encontrado: {{nome}}',
  falha: {
    titulo: 'Não encontramos seu cadastro',
    descricao:
      'Não conseguimos associar seu login a um cadastro de profissional. Procure a equipe responsável pela campanha.',
  },
  ultimoConhecido: 'Exibindo a última verificação; o cadastro está temporariamente indisponível.',
} as const;
